<template>
  <div class="all-identities-data">
    <!-- 角色头像列表 -->
    <div class="require" v-show="showIdentityScroll">
      <p>所需资料</p>
      <div id="all-identities-icon-wrapper">
        <ul class="choose slides">
          <li
            v-for="(item, index) in allIdentitiesDatas"
            :class="[active === index ? 'active' : '', 'job']"
            :key="index"
          >
            <span>
              <img
                v-if="active === index"
                :src="getIdentityIcon(item.identity_id, true)"
                alt="identity-icon-active"
              />
              <img
                v-else
                :src="getIdentityIcon(item.identity_id, false)"
                :class="[active === index ? '' : 'visible']"
                alt="identity-icon"
              /><span v-text="identitiesArr[item.identity_id]"></span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <!--当前角色需要的资料列表-->
    <div class="require_data" v-if="activeIdentity">
      <!--App拍摄资料-->
      <div class="app-data" v-if="activeIdentity.elec.length > 0">
        <p>App拍摄资料</p>
        <ul class="disc">
          <li v-if="haveIdPhoto">照片（App拍摄）<span class="imp">*</span></li>
          <li v-for="material in activeIdentity.elec" :key="material.elec_id">
            <span v-text="material.elec_name"></span
            ><span v-if="material.type === 1" class="imp">*</span>
          </li>
        </ul>
      </div>

      <!--邮寄资料-->
      <div class="email-data" v-if="activeIdentity.papery.length > 0">
        <p>邮寄资料</p>
        <ul class="disc">
          <li
            v-for="material in activeIdentity.papery"
            :key="material.paper_id"
          >
            <span v-text="material.paper_name"></span
            ><span v-if="material.type === 1" class="imp">*</span>
          </li>
        </ul>
      </div>

      <!--面试携带资料-->
      <div class="view-data" v-if="activeIdentity.take.length > 0">
        <p>面试携带资料</p>
        <ul class="disc">
          <li
            v-for="material in activeIdentity.take"
            :key="material.take_along_id"
          >
            <span v-text="material.take_along_name"></span
            ><span v-if="material.type === 1" class="imp">*</span>
          </li>
        </ul>
      </div>

      <!--操作-->
      <p class="explain">带<span class="imp">*</span>为必备资料</p>
      <div class="detail" v-on:click="popShow">查看详情</div>
    </div>

    <!--划出-->
    <div
      class="require_data require-pop pop-move"
      v-bind:class="[showPopup ? 'fixed-show' : 'fixed-hidden']"
      @touchstart.stop="stop"
    >
      <div class="pop-header pop-move">
        <img
          src="../../static/img/close@2x.png"
          v-on:click="popHidden"
          class="close-pop"
        />
        <span
          v-text="identitiesArr[allIdentitiesDatas[active].identity_id]"
        ></span>
      </div>
      <materials-of-indentity
        :active-identity="activeIdentity"
        :have-id-photo="haveIdPhoto"
        :show-sample-and-template="true"
      />
    </div>
  </div>
</template>
<script>
import Alloytouch from 'alloytouch';
import Transform from 'alloytouch/transformjs/transform';
import ProductService from '../services/productService.js';
import materialsOfIndentity from './materialsOfIndentity';

export default {
  name: 'allIdentitiesData',
  data() {
    return {
      active: 0,
      showIdentityScroll: false,
      identitiesArr: [
        '在职人员',
        '自由职业者',
        '退休人员',
        '在校学生',
        '学龄前儿童',
      ],
      showPopup: window.showPopup,
      activeIdentity: null,
      productService: new ProductService(this.$http),
    };
  },
  props: {
    productMaterial: {
      type: Array,
      default() {
        return [];
      },
    },

    // 虽然传递的是数字但是还是当布尔值用
    haveIdPhoto: {
      type: Number,
    },
  },
  mounted() {
    this.setIndentityScrollBindEvent();
  },
  components: {
    materialsOfIndentity,
  },
  computed: {
    /**
     * 当前所有身份排序过后的数据
     */
    allIdentitiesDatas() {
      if (!this.productMaterial) return [];
      return this.productService.sortIdentitiesData(this.productMaterial);
    },

    /**
     * 当前所有身份按照顺序排出来并处理了资料的列表
     */
    parsedIndentitiesDatas() {
      if (!this.productMaterial) return [];
      return this.productService.parseIdentitiesData(this.allIdentitiesDatas);
    },
  },
  methods: {
    /**
     * 设置身份块的滚动与事件绑定
     * @return {Null}
     */
    setIndentityScrollBindEvent() {
      // 内容的外容器
      const slides = this.$el.querySelector('.slides');
      if (slides) {
        const identities = slides.querySelectorAll('li');
        const identityIcons = slides.querySelectorAll('img');
        const identitiesLength = identities.length;
        const centerOfIndetities = Math.ceil(identitiesLength / 2);

        Transform(slides);

        const scroll = this.createSroll(slides, identitiesLength);

        this.setActiveIdentity(centerOfIndetities - 1);
        scroll.to(-(centerOfIndetities - 1) * 90, 0);

        this.bindClick(slides, identityIcons, scroll);
      }

      this.showIdentityScroll = true;
    },

    /**
     * 创建一个Scroll对象
     * @param {Object} slides 滚动容器
     * @param {Number} identitiesLength 身份数量
     * @return {Object} Scroll对象
     */
    createSroll(slides, identitiesLength) {
      return new Alloytouch({
        touch: '#all-identities-icon-wrapper',
        vertical: false,
        target: slides,
        property: 'translateX',
        min: -(identitiesLength - 1) * 90,
        max: 0,
        step: 90,
        preventDefault: false,
        animationEnd: (value) => {
          this.setActiveIdentity(-Math.round(value / 90));
        },
      });
    },

    /**
     * 绑定点击事件
     * @param {Object} slides 滚动容器
     * @param {Array} identityIcons 所有身份的图标
     * @param {Object} scroll Scroll对象
     * @return {Null}
     */
    bindClick(slides, identityIcons, scroll) {
      slides.addEventListener(
        'click',
        (event) => {
          const iconImage = event.target;
          event.preventDefault();
          event.stopPropagation();

          if (iconImage.nodeName.toLowerCase() === 'img') {
            [...identityIcons].forEach((item, index, arr) => {
              if (arr[index].src === iconImage.src) {
                scroll.to(-index * 90);
              }
            });
          }
        },
        false,
      );
    },

    /**
     * 设置当前激活的身份
     * @param {Number} activeIndex 激活的身份index
     * @return {Null}
     */
    setActiveIdentity(activeIndex) {
      this.active = activeIndex;
      this.activeIdentity = this.parsedIndentitiesDatas[activeIndex];
    },

    /**
     * 显示滑出框
     * @return {Null}
     */
    popShow() {
      this.showPopup = true;
      window.showPopup = true;
      const body = document.body;
      const h = Math.max(body.scrollTop, document.documentElement.scrollTop);
      body.style.position = 'fixed';
      body.style.width = '100%';
      body.style.top = `${-h}px`;
    },

    /**
     * 隐藏滑出框
     * @return {Null}
     */
    popHidden() {
      this.showPopup = false;
      window.showPopup = false;
      const body = document.body;
      const h = body.style.top;
      body.style.position = 'static';
      body.scrollTop = -parseInt(h);
    },

    /**
     * 获取身份的图片地址
     * @param {Number} id 身份编号
     * @param {Boolean} activeIndex 当前是否激活
     * @return {String} 激活或者不激活的身份图片地址
     */
    getIdentityIcon(id, activeIndex) {
      try {
        const suffix = activeIndex ? 'a' : '';
        return require(`../../static/img/id-${id}-${suffix}@2x.png`);
      } catch (e) {
        console.error(
          `图标加载失败: id-${id}-${activeIndex ? 'a' : ''}@2x.png`,
          e,
        );
        return '';
      }
    },

    stop() {},
  },
};
</script>
<style scoped>
span.imp {
  color: #ff5a60;
  margin: 0 0.05rem;
}
.require {
  margin-top: 15px;
  height: 137px;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding-top: 15px;
  overflow: hidden;
  font-size: 0;
  position: relative;
}
.require_data:before {
  content: '';
  width: 0;
  height: 0;
  border-left: 0.07rem solid transparent;
  border-right: 0.07rem solid transparent;
  border-bottom: 0.08rem solid #f0f0f0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -0.08rem;
}
.require_data:after {
  content: '';
  width: 0;
  height: 0;
  border-left: 0.07rem solid transparent;
  border-right: 0.07rem solid transparent;
  border-bottom: 0.08rem solid #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -0.07rem;
}
.require p {
  text-align: center;
  color: #6f6f6f;
  font-size: 0.14rem;
}
.require .choose {
  display: flex;
  width: 500px;
}
.require .choose li {
  padding: 10px;
  height: 100px;
  width: 70px;
  text-align: center;
  transition: all 0.1s;
}
.require img {
  width: 50px;
  height: 50px;
  padding: 10px;
  padding-bottom: 1px;
}
.job {
  color: #cfcfcf;
  font-size: 0.14rem;
}
#all-identities-icon-wrapper {
  width: 90px;
  height: 120px;
  margin: auto;
}
.active {
  transform: scale(1.2);
  color: #ff5a60;
}
.require_data {
  font-size: 0.15rem;
  padding-left: 0.11rem;
  background-color: #fff;
  padding-bottom: 0.2rem;
  padding-top: 0.15rem;
  position: relative;
}
.require_data li {
  margin-bottom: 0.14rem;
  position: relative;
}
.require_data li::before {
  content: '';
  width: 0.04rem;
  height: 0.04rem;
  background-color: #6f6f6f;
  position: absolute;
  top: 0.07rem;
  left: -0.1rem;
  border-radius: 50%;
}
.require_data p {
  padding-bottom: 0.15rem;
  color: #444;
  display: flex;
}
.require_data ul.disc {
  list-style: none;
  padding-left: 0.15rem;
  color: #6f6f6f;
}
.explain {
  font-size: 0.12rem;
  color: #aaa;
}
.detail {
  margin: auto;
  width: 1.6rem;
  height: 0.38rem;
  border: 1px solid #f98483;
  color: #f98483;
  text-align: center;
  border-radius: 0.03rem;
  line-height: 0.38rem;
  -webkit-tap-highlight-color: transparent;
}
.email-data,
.view-data,
.detail,
.explain {
  margin-top: 0.2rem;
}

.circle {
  display: inline-block;
  width: 0.05rem;
  height: 0.05rem;
  background-color: #aaa;
  border-radius: 50%;
  margin: 0 0.05rem;
}
.disc .flex-center {
  align-items: center;
  color: #aaa;
  line-height: 0.24rem;
  font-size: 0.14rem;
}

.fixed-show {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background-color: rgba(255, 255, 255, 0.95);
}
.pop-header {
  position: fixed;
  margin-bottom: 0.12rem;
  height: 0.44rem;
  width: 100%;
  text-align: center;
  font-size: 0.18rem;
  left: 0;
  top: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  z-index: 99999;
  border-bottom: 1px solid #f0f0f0;
}
.fixed-show .pop-header {
  top: 0;
}
.fixed-hidden {
  position: fixed;
  left: 0;
  top: 105%;
  right: 0;
  z-index: 99999;
  background-color: rgba(255, 255, 255, 0.95);
}
.pop-body {
  overflow: auto;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
.require-pop {
  padding: 0.45rem 0.2rem 0rem 0.1rem;
}

.close-pop {
  width: 0.24rem;
  height: 0.24rem;
  position: absolute;
  right: 0.13rem;
  top: 0.1rem;
}

#padding-0 {
  padding-left: 0;
}
.pop-move {
  transition: all 0.5s;
}
</style>
